// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"273":"8db8886a","319":"cfe31133","476":"1407c9b7","479":"1f64284a","782":"ee713b31","870":"c7e4e11d"}[chunkId] + ".chunk.js";
};